import { cartItemsAtom as D, giftCardsAtom as F, roomsAvailabilityAtom as w, summaryButtonAtom as U, setSummaryButtonAtom as K } from "./index34.mjs";
import { getConfigPropertyAtomCreator as V, ConfigProperty as Y, ViewLayout as z } from "./index13.mjs";
import { handleNextStepAtom as H, bookingSummaryShowAtom as X } from "./index25.mjs";
import { formatPrice as G } from "./index110.mjs";
import { calculateTotalPrice as h } from "./index111.mjs";
import { useAtomValue as r, useSetAtom as W } from "jotai";
import e, { useState as I, useMemo as j, useEffect as y } from "react";
import o from "./index112.mjs";
import f from "classnames";
import { Drawer as q } from "@amenitiz/design-system";
import { track as E } from "./index9.mjs";
import { TRACK_EVENT_TYPE as a, TRACK_EVENT as _ } from "./index10.mjs";
import { useHotelConfig as J } from "./index93.mjs";
import { getSubscriptionPlanRoot as b } from "./index14.mjs";
import { CollapsedHeader as Q } from "./index113.mjs";
import { BookingSummaryContent as Z } from "./index37.mjs";
import { CapacityBanner as $ } from "./index114.mjs";
import { useCapacityCheck as ee } from "./index115.mjs";
const te = ({
  totalPrice: n,
  currency: s
}) => /* @__PURE__ */ e.createElement("div", { className: o.footer }, /* @__PURE__ */ e.createElement("div", null, I18n.t("booking_engine.room.total")), /* @__PURE__ */ e.createElement("div", null, G(parseFloat(n), s))), Se = ({
  currentStep: n,
  setCurrentStep: s,
  isSidePanelExpanded: C
}) => {
  const O = r(H), i = r(D), m = r(F), M = r(X), g = r(w), [S, A] = I("0.00"), [t, k] = I(!1), L = r(U), N = W(K), T = ee(), P = !!document.getElementById("payment-step"), x = !!document.getElementById("client-details-step"), { hotelId: l, propertySize: c, propertyType: p, subscriptionPlan: u } = J(), R = r(
    j(() => V(Y.VIEW_LAYOUT), [])
  );
  y(() => {
    N({
      disabled: !T
    });
  }, [T, N]), y(() => {
    i.length && A(
      h({
        cartItems: i
      })
    );
  }, [i, n, P]), y(() => {
    m.length && A(
      h({
        giftCards: m
      })
    );
  }, [m]);
  const B = async () => {
    if (n === 1) {
      const d = t ? a.ROOM_SELECTION_FROM_SUMMARY_COMPLETED : a.ROOM_SELECTION_COMPLETED;
      E(_.CLICK, d, {
        hotel_id: l,
        property_type: p,
        property_size: c,
        subscription_plan: b(u)
      });
    } else if (n === 2) {
      const d = x ? a.GUEST_INFO_COMPLETED : a.EXTRAS_COMPLETED;
      E(_.CLICK, d, {
        hotel_id: l,
        property_type: p,
        property_size: c,
        subscription_plan: b(u)
      });
    }
    k(!1), O.onNextStep() && s(n + 1);
  }, v = () => {
    E(
      _.CLICK,
      t ? a.SUMMARY_COLLAPSED : a.SUMMARY_EXPANDED,
      {
        hotel_id: l,
        property_type: p,
        property_size: c,
        subscription_plan: b(u)
      }
    ), k(!t);
  };
  return !i.length && !m.length || !M ? null : /* @__PURE__ */ e.createElement(
    "div",
    {
      className: f(o.booking_summary_container, {
        [o.booking_summary_container_expanded]: C
      })
    },
    /* @__PURE__ */ e.createElement(
      "div",
      {
        "data-testid": "booking-summary-container",
        className: f(o["booking-summary-container"], {
          [o["booking-summary-container-expanded"]]: C,
          [o["booking-summary-container-full-screen"]]: R === z.FULL_SCREEN,
          [o["booking-summary-container-opened"]]: t
        })
      },
      /* @__PURE__ */ e.createElement(
        q,
        {
          "data-testid": "booking-summary",
          classes: f(o["booking-summary"], {
            [o["booking-summary-expanded"]]: t
          }),
          isExpandable: !0,
          dismissable: !1,
          defaultOpened: !0,
          hasCloseButton: !1,
          variant: "white",
          submitButtonLabel: L.label,
          isSubmitButtonDisabled: L.disabled,
          onSubmit: B,
          isExpanded: t,
          overflowBody: "hidden",
          bodyFooter: t ? /* @__PURE__ */ e.createElement(
            te,
            {
              totalPrice: S,
              currency: g.currency
            }
          ) : null,
          bodyHeader: t ? null : /* @__PURE__ */ e.createElement($, null),
          expandableIconOnClick: v
        },
        t ? /* @__PURE__ */ e.createElement(Z, { displaysInsideModal: !1 }) : /* @__PURE__ */ e.createElement(
          Q,
          {
            totalPrice: S,
            currency: g.currency
          }
        )
      )
    )
  );
};
export {
  Se as BookingSummary
};
